import React from 'react';
import i18n from '../../../i18n';
import {Field, withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";
class Cranes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
            hasMounted: true,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={16} alignItems="center">
                        <Grid item xs={8}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="cost_center"
                                label='Kostenstelle:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.cost_center}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="producer"
                                label='Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="serial_number"
                                label='Serienummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="type"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="load_capacity"
                                label='Tragfähigkeit:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.load_capacity}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="number"
                                name="construction_year"
                                label='Baujahr:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                                inputProps={{
                                    max : 2100
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="inventory_no"
                                label='Inventar Nr.:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_no}
                                inputProps={{
                                    maxLength : 20
                                }}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Bauart:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="crane1"
                                        label='Brückenkran'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane1}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="crane2"
                                        label='Vollportalkran'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="crane3"
                                        label='Hängekran'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="crane4"
                                        label='Schwenkarmkran'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane4}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="crane5"
                                        label='Halbportalkran'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane5}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="crane6"
                                        label='Regalbediengerät'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane6}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="crane7"
                                        label='Schienenlaufkatze'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.crane7}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Tragfähigkeit kg/t:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container spacing={16}>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormField
                                        type="number"
                                        name="main_hoist"
                                        label="Haupthubwerk:"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.main_hoist}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormField
                                        type="number"
                                        name="hoist_2"
                                        label='Hubwerk 2:'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.hoist_2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormField
                                        type="number"
                                        name="hoist_3"
                                        label='Hubwerk 3:'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.hoist_3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormField
                                        type="number"
                                        name="rotary_trolley"
                                        label='Drehlaufkatze:'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.rotary_trolley}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Steuerung:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="cab"
                                        label='Führerhaus'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.cab}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="kabellos_gesteuert"
                                        label='Kabellos gesteuert'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.kabellos_gesteuert}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="kabel_gebunden"
                                        label='kabelgebunden'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.kabel_gebunden }
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="automatiksteuerung"
                                        label='Automatiksteuerung'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.automatiksteuerung}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Table width="90% !important">
                    <TableHead>
                        <TableRow>
                            <TableCell width="30%">
                                &nbsp;
                            </TableCell>
                            <TableCell width="40%">
                            </TableCell>
                            <TableCell width="30%">
                                erforderliche Maßnahmen
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        1. Sichtprüfung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Identität:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fabrikschild: Kran (Hersteller/ Lieferant, Baujahr, Fabr.Nr, Typ)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="factory_plate"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.factory_plate || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="factory_plate_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.factory_plate_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        weitere Beschilderung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Belastungsangaben
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="load_information"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.load_information || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="load_information_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.load_information_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Aushang Betriebsvorschriften
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="notice_of_regulations"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.notice_of_regulations || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="notice_of_regulations_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.notice_of_regulations_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verbotsschild (Aufstieg durch Unbefugte verboten)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="sign_prohibited"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.sign_prohibited || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="sign_prohibited_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.sign_prohibited_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung Netzanschlußschalter
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="main_connection_swtich"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.main_connection_swtich || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="main_connection_swtich_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.main_connection_swtich_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung Gefahrenstellen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="danger_spots"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.danger_spots || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="danger_spots_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.danger_spots_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                CE-Kennzeichnung (ab 01.01.1995)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="ce_marking"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.ce_marking || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="ce_marking_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.ce_marking_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Aufstellung und Ausrüstung:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Tragkonstruktion, Kranbahnfundamente
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="support_structure"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.support_structure || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="support_structure_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.support_structure_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Haken (Y-Maß 10%; h25%, Hakenmaulsicherung, Korrosien, Risse)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="hook"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.hook || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="hook_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.hook_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Hakenflansche (Eignung, Hakenbefestigung, Handgriffe)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="hook_flanges"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.hook_flanges || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="hook_flanges_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.hook_flanges_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Begehung des Kranes:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zugang zum Steuerstand/ Aufstiege (z.B. Treppen, Leitern, Rückenschutz,Podeste)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="access_to_steering"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.access_to_steering || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="access_to_steering_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.access_to_steering_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Podeste, Bühne, Laufstege {'&'} Geländer (LE1, Fahrbahn-/Krantägerlaufsteg, 2. Zwtschenstab)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="paltform_railings"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.paltform_railings || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="paltform_railings_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.paltform_railings_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitsabstände
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="safety_distance"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.safety_distance || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="safety_distance_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.safety_distance_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitseinrichtung (Vorhandensein/ Vollständigkeit soweit zugänglich und/ oder sichtbar)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="safety_device"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.safety_device || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="safety_device_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.safety_device_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Winde/ Seil (Machart; 10% Verschleiß bzw. 15% v. 0; Drahtbrüche, Befestigung)-Bordscheibe (1,5xd)- Seilrollen Aussetzbügel-Spiel 1/3xd oder max 10 mm)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="rope"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.rope || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="rope_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.rope_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Bremseinrichtungen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="breaking_device"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.breaking_device || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="breaking_device_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.breaking_device_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Drehkranz (Befestigung, Kippspiel nach Herstellerangeben)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="slewing_ring"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.slewing_ring || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="slewing_ring_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.slewing_ring_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Puffer und Pufferanschlag
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="buffer_and_buffer_stop"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.buffer_and_buffer_stop || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="buffer_and_buffer_stop_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.buffer_and_buffer_stop_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Kontrolle des Kranes einschl. Kranbahn:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                elektr./hydr./pneum. Ausrüstung (Verlegung, Beschädigung v. z.B. Schleifleitung, Stomabnehmer, Leitungswagensystem, Leitungstrommel)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="electr_hydr_pneum_equipment"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.electr_hydr_pneum_equipment || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="electr_hydr_pneum_equipment_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.electr_hydr_pneum_equipment_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Steuerstand/ Führerhaus:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung Stellteile
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="marking_control_elements"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.marking_control_elements || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="marking_control_elements_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.marking_control_elements_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Aushang Betriebsvorschriften
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="notice_operating_regulations"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.notice_operating_regulations || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="notice_operating_regulations_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.notice_operating_regulations_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sitz, Stellteile, Türen, Fenster/ Scheiben, Heizung, Lüftung
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="seat_doors_others"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.seat_doors_others || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="seat_doors_others_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.seat_doors_others_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        2. Funktionsprüfung:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell colSpan={2}>
                                <FormRadio
                                    name="functional_testing"
                                    options={[
                                        {
                                            value : 'with',
                                            label : 'mit Last'
                                        },
                                        {
                                            value : 'without',
                                            label : 'ohne Last'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.functional_testing || ''}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Notbefehlseinrichtung (Nothalt)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="emergency_stop"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.emergency_stop || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="emergency_stop_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.emergency_stop_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Nullstellung der Stellteile
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="zero_setting_control"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.zero_setting_control || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="zero_setting_control_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.zero_setting_control_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Bremsprüfung (1. Loslassen Stellteil und 2. Nothalt):
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Hubwerk
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="hoist"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.hoist || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="hoist_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.hoist_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kranfahrt
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="crane_travel"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.crane_travel || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="crane_travel_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.crane_travel_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Katzfahrt
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="cat_ride"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.cat_ride || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="cat_ride_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.cat_ride_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Drehwerk
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="slewing_gear"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.slewing_gear || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="slewing_gear_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.slewing_gear_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Verfahren des Kranes/ Katze/ Drehwerk/ Hubwerk über gesamten Weg in allen Stufen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitsabstände
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="safety_distances"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.safety_distances || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="safety_distances_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.safety_distances_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Geräusche/ Schwingungen (auffällige)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="noises_vibrations"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.noises_vibrations || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="noises_vibrations_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.noises_vibrations_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <b>
                                    <u>
                                        Anfahren aller vorhandenen Sicherheitseinrichtungen:
                                    </u>
                                </b>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Hubbegrenzer (Betriebs- und Notfunktion)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="stroke_limiter"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.stroke_limiter || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="stroke_limiter_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.stroke_limiter_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Senkbegrenzer (2 Windungen)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="lowering_limiter"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.lowering_limiter || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="lowering_limiter_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.lowering_limiter_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kranfahrt
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="crane_travels"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.crane_travels || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="crane_travels_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.crane_travels_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Katzfahrt
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="cat_rides"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.cat_rides || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="cat_rides_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.cat_rides_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Drehweg
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="turning_path"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.turning_path || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="turning_path_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.turning_path_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Distanzierungseinrichtungen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="destancing_device"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.destancing_device || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="destancing_device_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.destancing_device_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Schlaffseil
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="slack_rope"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.slack_rope || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="slack_rope_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.slack_rope_remark}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Drehkranzspiel (Hinweis in der Betriebsanleitung beachten)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="head_play"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'vorhanden'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'nicht vorhanden'
                                        },
                                        {
                                            value : 'free',
                                            label : 'Korrektur'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadioSelection}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.head_play || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="head_play_remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.head_play_remark}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={3}>
                                    <FormField
                                        type="text"
                                        name="notations"
                                        label='Bemerkungen:'
                                        multiline
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.notations}
                                    />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px',
    },
    formRadioSelection: {
        flexDirection: "row",
    },
    formButton: {
    },
    formSelection: {
    }
});

export default withStyles(styles)(Cranes)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/Cranes.js